import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchRateLimits, deleteRateLimit } from "actions/rateLimit";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import Table from "./Table";
import Pagination from "components/Pagination";

class RateLimitIndex extends Component {
  componentDidMount() {
    this.props.fetchRateLimits();

    this.search = {};
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.props.fetchRateLimits({ ...this.search });
  };

  onPaginationClick = page => event => {
    const { rateLimitURL: rateLimit_url } = this.props.match.params;
    this.props.fetchRateLimits({ rateLimit_url, page, ...this.search });
  };

  handleRateLimitDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deleteRateLimitProcess(id);
      },
      title: "Delete rateLimit",
      body: "Are you sure you want to delete this rateLimit?"
    });
  };

  deleteRateLimitProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteRateLimit, match } = this.props;
    const { rateLimitURL: rateLimit_url } = match.params;
    deleteRateLimit(id, { rateLimit_url })
      .then(() => {
        this.props.fetchRateLimits({ ...this.search });
        toggleNotification(true, { infoClassName: "is-success", message: "Delete RateLimit Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { rateLimits } = this.props;

    return (
      <div>
        <div className="box">
          <Table rateLimits={rateLimits} onClickDelete={this.handleRateLimitDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={rateLimits.current_page}
            lastPage={rateLimits.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authRateLimit, rateLimits, confirmationPopupActive }) => ({
  authRateLimit,
  rateLimits,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchRateLimits, deleteRateLimit, toggleconfirmationPopup, toggleNotification }
)(RateLimitIndex);



// WEBPACK FOOTER //
// ./src/pages/RateLimit/Index/index.js